<template lang="pug">
  div
    global-nav
    div.container
      transition(:name="transition" mode="out-in")
        router-view
    foot
      b
        a(href='https://projects.fivethirtyeight.com/trump-approval-ratings/' target='_blank') Trump Approval Ratings&nbsp;
</template>

<script>
import Nav from './components/Nav'
import Foot from './components/Footer'

export default {
  name: 'app',
  components: {
    'global-nav': Nav,
    Foot
  },
  data () {
    return {
      transition: 'fade'
    }
  }
}
</script>

<style lang="sass">
// @import './assets/bulma.sass'
// @import '../node_modules/bulma/bulma.sass'
</style>

<style lang="stylus">
@import './assets/_variables.styl'
@import './assets/global.styl'
@import './assets/_transition.styl'
// html {
//   font-size: responsive 12px 21px;
//   font-range: 420px 1280px;
// }
html {
  font-size: responsive;
  min-font-size: 0.5rem;
  max-font-size: 1.4rem;
  lower-font-range: 420px;
  upper-font-range: 1280px;
}
</style>



// WEBPACK FOOTER //
// App.vue?46a47cbe